import { STATUS_CTA, CTA_LABEL_KEY } from '../constants';

/**
 * Maps a raw attention item (from `integrationsService.listAttentionItems`) to
 * the UI shape the Needs Your Attention band renders: the meta line (category +
 * usage), the contextual CTA (id + i18n label key), the connected-by avatar, and
 * the "Fix now" navigation target.
 *
 * The "Fix now" link targets the affected instance's detail page; until Instance
 * Detail lands (CT-3897) it points at the provider page.
 *
 * TODO(CT-3897): retarget `fixHref` to the instance detail route once it exists.
 */
export const mapAttentionItemToUi = (item) => {
  const cta = STATUS_CTA[item.status] ?? null;
  return {
    id: item.id,
    slug: item.slug,
    name: item.name,
    category: item.category,
    status: item.status,
    instanceName: item.instance_name ?? null,
    callsPerDay: item.calls_per_day ?? 0,
    usedInWorkflows: item.used_in_workflows ?? 0,
    connectedBy: item.connected_by ?? null,
    cta,
    ctaLabelKey: cta ? (CTA_LABEL_KEY[cta] ?? null) : null,
    fixHref: item.slug, // relative to /admin-studio/integrations
  };
};
